import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BookContext } from "../../contexts/BookContext";

export const DownloadAudioBookButton: FC = () => {
  const { t } = useTranslation();
  const { book } = useContext(BookContext);

  const url = book?.zip_url || "";

  return (
    <a
      href={url || undefined}
      download
      onClick={url === "" ? (e) => e.preventDefault() : undefined}
      className={`flex w-full items-center justify-center bg-delicate-800 ${
        url === ""
          ? "bg-gray-400 cursor-not-allowed pointer-events-none"
          : "hover:bg-delicate-500"
      } text-white text-lg rounded px-4 py-2`}
      aria-disabled={url === ""}
      tabIndex={url === "" ? -1 : 0}
    >
      <ArrowDownTrayIcon className="h-6 w-6 mr-2" />
      {t("dashboard.download_audiobook")}
    </a>
  );
};
